import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Umbrella: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6626 3.81812C6.35011 3.81812 3.27276 7.99953 2.3275 11.2882C2.09279 12.1048 3.07926 12.6658 3.88819 12.4061C4.35336 12.2567 4.88336 12.1514 5.45347 12.1514C6.54387 12.1514 7.37265 12.408 7.94773 12.7077C8.48452 12.9873 9.253 13.0396 9.79783 12.7759C10.4752 12.4481 11.4481 12.1514 12.6626 12.1514C13.5773 12.1514 14.2766 12.2917 14.8079 12.4966C15.4951 12.7616 16.6712 12.7562 17.3548 12.4819C17.8455 12.285 18.4283 12.1514 19.0235 12.1514C19.3838 12.1514 19.732 12.2102 20.0573 12.3042C20.8887 12.5447 21.9814 12.0206 21.8235 11.1696C21.2167 7.89989 18.8993 3.81812 12.6626 3.81812Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M16.5226 20.7241C16.7784 20.2347 16.5891 19.6305 16.0996 19.3746C15.6102 19.1188 15.006 19.3082 14.7501 19.7976L16.5226 20.7241ZM11 12V20.2609H13V12H11ZM11 20.2609C11 20.6691 11.0896 21.2863 11.4019 21.8394C11.7413 22.4407 12.3787 23 13.3636 23V21C13.2786 21 13.2495 20.9806 13.24 20.9744C13.2222 20.9627 13.1862 20.9318 13.1435 20.8562C13.0467 20.6848 13 20.4324 13 20.2609H11ZM13.3636 23C14.2664 23 14.9911 22.5265 15.4724 22.0839C15.9638 21.6319 16.326 21.1001 16.5226 20.7241L14.7501 19.7976C14.6437 20.0013 14.415 20.3391 14.1185 20.6118C13.8119 20.8938 13.5518 21 13.3636 21V23Z"
        fill={color}
      />
      <path
        d="M13 2C13 1.44772 12.5523 1 12 1C11.4477 1 11 1.44772 11 2H13ZM13 3.81818V2H11V3.81818H13Z"
        fill={color}
      />
      <path
        d="M8.56618 12.6891C8.43521 9.64648 8.14755 4.015 12.2576 3.7929C16.3677 3.5708 16.3185 9.79002 16.3068 12.6728"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Umbrella;
